import frequentlyUse from './frequentlyUse'
import mathFormula from './mathFormula'

export default [
  // 常用函数
  frequentlyUse,
  mathFormula,
]
